module.exports = __webpack_public_path__ + "assets/img/qrcode_wx.fcd88437.jpg";